import { Currency } from '@/types';

export const toLocaleCurrencyString = (amount: number, currency: Currency) => {
  return Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: Number.isInteger(amount) ? 0 : undefined, // 整数の場合は小数点以下を表示しない
  }).format(amount);
};
